__turbopack_context__.v({
  "className": "inter_1ba745b5-module__piQoma__className",
  "variable": "inter_1ba745b5-module__piQoma__variable",
});
